<template>
  <van-overlay :show="show" @click="cancel" :z-index="101">
    <div class="popup">
      <!-- <img class="box" :src="`${resBaseUrl}gift-box01.png`" alt="" /> -->
      <div class="content">
        <div class="amount_title">{{ $t('envelope.receiveCash') }}</div>
        <div class="amount">
          {{ reward ? reward.currentReward : '--' }}
          {{ balance && balance.currencyAlias ? balance.currencyAlias : defaultCurrencyAlias() }}
        </div>
        <div class="progress">
          <div class="bar" :style="`width: ${progress}%;`">
            <div class="desc">
              {{
                $t('envelope.stillShort', {
                  value: reward
                    ? Math.round((reward.totalReward - reward.currentReward) * 100) / 100
                    : '--'
                })
              }}
            </div>
          </div>
        </div>
        <div class="title">
          {{ $t('envelope.inviteFriends') }}
          <span style="color: #8400ff">{{ $t('envelope.cash') }}</span>
        </div>
        <div class="invite-share">
          <div
            class="invite-icon"
            v-for="(item, index) in inviteIcon"
            :key="index"
            @click="onShare(item)"
          >
            <img class="invite-img" :src="item.url" alt="" />
            <div class="invite-name" :style="`margin-left:-${item.offX}rem;color:${item.color}`">
              {{ item.name }}
            </div>
            <img
              class="guid"
              v-if="index == 0 && !isFinishGuide"
              :src="guidHand"
              alt=""
              srcset=""
            />
          </div>
        </div>
        <div class="link-content">
          <div class="link-url">
            {{ truncateText(shareLink, 28) }}
          </div>
          <div class="link-copy" @click="onCopy">{{ $t('envelope.copy') }}</div>
        </div>
      </div>
      <div class="share-button">{{ $t('envelope.share') }}</div>
    </div>
  </van-overlay>
</template>

<script>
import { config } from '@/common/config'
import { Key, setLocalStorage } from '@/common/localStorage'
import { REPORT_EVENT, reportGtag } from '@/common/mgtag'
import { getLocale } from '@/locales'
import { useEnvelopeStore } from '@/stores/envelope'
import { useUserStore } from '@/stores/user'
import {
  copy,
  defaultCurrencyAlias,
  encodeBase64,
  formatMoney,
  truncateText,
  unitConversion
} from '@/utils/helper'
import dayjs from 'dayjs'
import { mapActions, mapState } from 'pinia'
export default {
  name: 'LobbyActiveSharePopup',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    cancel: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      progress: 60,
      inviteIcon: [
        {
          id: 1,
          url: `${config.resBaseUrl}invite-telegram-new.png`,
          name: 'Telegram',
          offX: 0,
          color: '#29A9EB'
        },
        {
          id: 2,
          url: `${config.resBaseUrl}invite-facebook-new.png`,
          name: 'Facebook',
          offX: 0,
          color: '#2973BA'
        },
        {
          id: 3,
          url: `${config.resBaseUrl}invite-whatsapp-new.png`,
          name: 'Whatapp',
          offX: 0,
          color: '#4DAD1F'
        },
        {
          id: 4,
          url: `${config.resBaseUrl}invite-sms-new.png`,
          name: 'SMS',
          offX: 0.2,
          color: '#13AEBB'
        }
        // { id: 5, url: `${config.resBaseUrl}invite-link-new.png`, name: 'Link', offX: 0, color: '#466ae5' }
      ],
      guidHand: `${config.resBaseUrl}clickgif.gif`,
      resBaseUrl: config.resBaseUrl,
      shareLink: window.location.href,
      shareText: 'Test test test',
      shareImage: 'https://res.megalake.games/lobby/gift-box01.png',
      isFinishGuide: true
    }
  },
  computed: {
    ...mapState(useEnvelopeStore, ['reward']),
    ...mapState(useUserStore, ['userInfo', 'balance', 'isLogin'])
  },
  mounted() {
    if (this.reward) {
      this.progress = Math.round((this.reward.currentReward / this.reward.totalReward) * 100)
    }
    this.guide().then((r) => {
      this.isFinishGuide = r.guide
    })
  },

  methods: {
    formatMoney,
    unitConversion,
    dayjs,
    copy,
    truncateText,
    defaultCurrencyAlias,
    ...mapActions(useEnvelopeStore, { share: 'share', domain: 'domain', guide: 'guide' }),
    ...mapActions(useUserStore, { updateUserInfo: 'updateUserInfo' }),
    onShare(item) {
      if (!this.userInfo.username) {
        this.updateUserInfo().then(() => {
          this.onShare(item)
        })
        return
      }
      this.domain().then((res) => {
        if (res.domain && res.domain != '') {
          this.shareLink = res.domain
        }
        this.shareLink +=
          '?id=' +
          encodeBase64(this.reward.id) +
          '&from=' +
          encodeBase64(this.userInfo.username) +
          '|' +
          encodeBase64(this.userInfo.userId) +
          '&lang=' +
          getLocale()
        this.share(this.reward.id)
          .then((res) => {
            console.log(res)
            setLocalStorage(Key.shared, 'true')
          })
          .finally(() => {
            // setLocalStorage(Key.clickShareIcon, true)
            switch (item.id) {
              case 1:
                window.location.href = this.telegramLink()
                break
              case 2:
                window.location.href = this.facebookLink()
                break
              case 3:
                window.location.href = this.whatsappLink()
                break
              case 4:
                window.location.href = this.smsLink()
                break
              case 5: {
                const randomNum = Math.floor(Math.random() * 3) // 生成 0 到 3 的随机整数
                const shareText = [
                  this.$t('envelope.copyshare.share1'),
                  this.$t('envelope.copyshare.share2'),
                  this.$t('envelope.copyshare.share3')
                ][Math.min(randomNum, 2)]
                this.shareLink += '&cid=hbcp&channel=web'
                this.copy(`${shareText} ${this.shareLink}`)
                break
              }
              default:
                break
            }
          })
      })
    },
    telegramLink() {
      reportGtag(REPORT_EVENT.ENVELOPE.POCKET_MONEY_withdraw_TG, 'click')
      const randomNum = Math.floor(Math.random() * 3) // 生成 0 到 3 的随机整数
      const shareText = [
        this.$t('envelope.telegram.share1'),
        this.$t('envelope.telegram.share2'),
        this.$t('envelope.telegram.share3')
      ][Math.min(randomNum, 2)]
      this.shareLink += '&cid=hbtg&channel=web'
      return `https://t.me/share/url?url=${encodeURIComponent(this.shareLink)}&text=${encodeURIComponent(shareText)}`
    },
    facebookLink() {
      reportGtag(REPORT_EVENT.ENVELOPE.POCKET_MONEY_withdraw_FB, 'click')
      const randomNum = Math.floor(Math.random() * 3) // 生成 0 到 3 的随机整数
      const shareText = [
        this.$t('envelope.facebook.share1'),
        this.$t('envelope.facebook.share2'),
        this.$t('envelope.facebook.share3')
      ][Math.min(randomNum, 2)]
      this.shareLink += '&cid=hbfb&channel=web'
      return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.shareLink)}&quote=${encodeURIComponent(shareText)}`
    },
    whatsappLink() {
      reportGtag(REPORT_EVENT.ENVELOPE.POCKET_MONEY_withdraw_whatapp, 'click')
      const randomNum = Math.floor(Math.random() * 3) // 生成 0 到 3 的随机整数
      const shareText = [
        this.$t('envelope.whatapp.share1'),
        this.$t('envelope.whatapp.share2'),
        this.$t('envelope.whatapp.share3')
      ][Math.min(randomNum, 2)]
      this.shareLink += '&cid=hbwh&channel=web'
      const message = `${shareText}: ${this.shareLink}`
      return `https://wa.me/?text=${encodeURIComponent(message)}`
    },
    smsLink() {
      reportGtag(REPORT_EVENT.ENVELOPE.POCKET_MONEY_withdraw_sms, 'click')
      const randomNum = Math.floor(Math.random() * 3) // 生成 0 到 3 的随机整数
      const shareText = [
        this.$t('envelope.sms.share1'),
        this.$t('envelope.sms.share2'),
        this.$t('envelope.sms.share3')
      ][Math.min(randomNum, 2)]
      this.shareLink += '&cid=hbsm&channel=web'
      return `sms:?&body=${encodeURIComponent(shareText + ' ' + this.shareLink)}`
    },
    onCopy() {
      reportGtag(REPORT_EVENT.ENVELOPE.POCKET_MONEY_index_copy, 'click')
      this.onShare({ id: 5 })
    }
  }
}
</script>

<style lang="scss" scoped>
.popup {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;

  // .box {
  //   width: 2rem;
  //   margin-bottom: 0.5rem;
  //   animation: breathing 0.8s infinite;
  // }

  .content {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    width: 6.4rem;
    height: auto;
    padding: 0.3rem 0;
    background: #f1f1f1;
    border-radius: 0.16rem;
    border: 1px solid #95a5a5;

    .amount_title {
      width: auto;
      height: 0.25rem;
      font-family: DroidSans;
      font-size: 0.24rem;
      color: #009944;
      line-height: 0.4rem;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-bottom: 0.3rem;
    }

    .amount {
      width: auto;
      height: 0.56rem;
      font-family: Oswald, Oswald;
      font-weight: bold;
      font-size: 0.6rem;
      color: #009944;
      line-height: NaNrem;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    .progress {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 5.59rem;
      height: 0.48rem;
      background: #211d28;
      border-radius: 0.24rem 0.24rem 0.24rem 0.24rem;
      margin-top: 0.5rem;

      .bar {
        display: flex;
        justify-content: flex-start;
        align-content: center;
        align-items: center;
        width: 4.04rem;
        height: 0.4rem;
        background: #009944;
        border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
        margin-left: 0.04rem;

        .desc {
          min-width: 5rem;
          height: 0.4rem;
          font-size: 0.24rem;
          line-height: 0.4rem;
          color: #ffffff;
          border-radius: 0.16rem 0.16rem 0.16rem 0.16rem;
          margin-left: 0.2rem;
          // border: 0.02rem solid #ffffff;
        }
      }
    }

    .title {
      // width: 3.42rem;
      height: 0.19rem;
      font-family: Droid Sans;
      font-weight: 400;
      font-size: 0.24rem;
      color: #000000;
      line-height: 0.4rem;
      margin-top: 0.3rem;
    }

    .invite-share {
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-top: 0.5rem;
      width: 6.4rem;

      .invite-icon {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 0.8rem;

        .invite-img {
          width: 0.8rem;
          height: 0.8rem;
        }

        .invite-name {
          width: auto;
          height: 0.25rem;
          font-family: Droid Sans;
          font-weight: 400;
          font-size: 0.24rem;
          color: #9ca0ab;
          line-height: 0.4rem;
          text-align: center;
        }

        .guid {
          position: absolute;
          margin-top: 0.1rem;
          margin-left: 0.3rem;
          width: 1.5rem;
        }
      }
    }

    .link-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 0.24rem;
      margin-top: 0.5rem;

      .link-url {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0 0.3rem;
        width: 3.55rem;
        height: 0.7rem;
        background: #ffffff;
        border-radius: 0.16rem;
        border: 0.01rem solid #95a5a5;
        margin-left: 0.4rem;

        font-family: Droid Sans;
        font-weight: 400;
        color: #9ca0ab;
        line-height: 0.22rem;
      }

      .link-copy {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 1.3rem;
        height: 0.7rem;
        background: #336aea;
        border-radius: 0.16rem;
        margin-left: 0.3rem;
        margin-right: 0.5rem;
      }
    }
  }

  .share-button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 6.4rem;
    height: 0.7rem;
    // background: #336aea;
    // border-radius: 0.16rem;
    margin-top: 0rem;

    font-family: Droid Sans;
    font-weight: 400;
    font-size: 0.24rem;
    color: #ffffff;
  }
}

@keyframes shake {
  0% {
    transform: translate(0, 0);
  }

  25% {
    transform: translate(-10px, 0);
  }

  50% {
    transform: translate(5px, 0);
  }

  75% {
    transform: translate(-10px, 0);
  }

  100% {
    transform: translate(0, 0);
  }
}

@keyframes breathing {
  0% {
    transform: scale(1);
    // opacity: 1;
  }

  50% {
    transform: scale(1.05);
    // opacity: 0.7;
  }

  100% {
    transform: scale(1);
    // opacity: 1;
  }
}
</style>
